import GraphicEditForm from "./graphic-edit-form";

export default GraphicEditForm;